module.exports = __webpack_public_path__ + "static/media/LOGO@2x.29fdc387.png";